// extracted by mini-css-extract-plugin
module.exports = {"myButton":"Button_myButton__Sc1PY"};